import { render } from "./PartContact.vue?vue&type=template&id=0c7ba7fc&scoped=true"
import script from "./PartContact.vue?vue&type=script&lang=js"
export * from "./PartContact.vue?vue&type=script&lang=js"

import "./PartContact.vue?vue&type=style&index=0&id=0c7ba7fc&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7ba7fc"]])

export default __exports__